module.exports = __webpack_public_path__ + "img/classsq.f8ff8002.png";